import { Button } from '@flos/react-ui';
import { FC } from 'react';
import useAppState from '../../state/appState';
import { conf } from '../../config/config';

type SubmitButtonProps = {
    onClick: () => void;
    submitIsLoading: boolean;
};

const SubmitButton: FC<SubmitButtonProps> = ({ submitIsLoading, onClick }) => {
    const formConfig = useAppState((state) => state.formConfig);

    if (!formConfig) {
        return <></>;
    }

    const submitButtonKey = formConfig.submitButton;
    const caption = conf.submitButtons[submitButtonKey];

    if (!caption) {
        throw new Error('Invalid submitButtonKey: ' + submitButtonKey);
    }

    // const caption = 'Send anmeldelse';
    return (
        <Button
            loadingText={caption}
            isLoading={submitIsLoading}
            onClick={onClick}
            disabled={submitIsLoading}
            size="medium"
        >
            {caption}
        </Button>
    );
};

export default SubmitButton;
